import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ApplyCTA } from "./ApplyCTA";
import { useT, useLang, pathForLang, LANGS } from "../../i18n";
import { setStoredPref } from "../../lib/langPref";

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const t = useT();
  const lang = useLang();
  const loc = useLocation();
  const homeHref = lang === "en" ? "/" : "/es";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      className={`sp-nav ${scrolled ? "is-scrolled" : ""}`}
      data-testid="site-nav"
    >
      <div className="sp-nav-inner">
        <Link
          to={`${homeHref}#top`}
          className="sp-nav-brand"
          data-testid="nav-brand"
          aria-label={`${t.nav.brand} — ${t.nav.tag}`}
        >
          <img
            src="/stella-polaris-star.png"
            alt=""
            data-testid="nav-logo"
          />
          <span className="sp-nav-brand-text">
            <span className="name">{t.nav.brand}</span>
            <span className="tag">{t.nav.tag}</span>
          </span>
        </Link>

        <div className="sp-nav-links" data-testid="nav-links">
          <a
            href={`${homeHref}#program`}
            data-testid="nav-link-program"
          >
            {t.nav.links.find((l) => l.href === "#program")?.label || "Program"}
          </a>
          <Link
            to={lang === "en" ? "/about" : "/es/about"}
            data-testid="nav-link-about"
          >
            {t.nav.about}
          </Link>
          <Link
            to={lang === "en" ? "/insights" : "/es/insights"}
            data-testid="nav-link-insights"
          >
            {t.nav.insights}
          </Link>
          <Link
            to={lang === "en" ? "/contact" : "/es/contact"}
            data-testid="nav-link-contact"
          >
            {t.nav.contact}
          </Link>
        </div>

        <div className="sp-nav-trailing">
          <div
            className="sp-lang-switch"
            role="group"
            aria-label="Language"
            data-testid="lang-switch"
          >
            {LANGS.map((code) => (
              <Link
                key={code}
                to={pathForLang(code, loc.pathname) + loc.hash}
                onClick={() => setStoredPref(code)}
                className={`sp-lang-btn ${code === lang ? "is-active" : ""}`}
                aria-current={code === lang ? "true" : undefined}
                data-testid={`lang-switch-${code}`}
                hrefLang={code}
              >
                {t.nav.langSwitch[code]}
              </Link>
            ))}
          </div>

          <ApplyCTA
            testId="nav-cta-apply"
            variant="primary"
            className="sp-nav-cta"
          >
            {t.nav.apply}
          </ApplyCTA>
        </div>
      </div>
    </nav>
  );
};
